import { MfaSetupKey } from '@_types/shared/Mfa';
import Form from '@components/form/Form';
import TextInput from '@components/form/TextInput';
import ActionButton from 'lib/src/components/button/ActionButton';
import ButtonRow from 'lib/src/components/button/ButtonRow';
import DataCheck from 'lib/src/components/common/DataCheck';
import FormRow from 'lib/src/components/form/FormRow';
import { isEmpty } from 'lib/src/utils/generic';
import QRCode from 'react-qr-code';

const MfaInner: React.FC<MfaInnerProps> = ({
    stage,
    setStage,
    isFetching,
    fetchError,
    mfaSetupKey,
    hasMfa,
    handleSubmit,
    isPosting,
    postError,
    formState,
    handleChange,
    cancelAction,
}) => {
    return (
        <>
            {stage === 'setup' && (
                <>
                    <DataCheck
                        isFetching={isFetching}
                        error={fetchError}
                        dataExists={!isEmpty(mfaSetupKey) && !isFetching}
                    >
                        <div className="wysiwyg">
                            <p>
                                To start setting up Multi-Factor Authentication (MFA), scan the QR
                                code below with your authenticator app.
                            </p>
                            <div className="mfa-wrapper">
                                <QRCode value={mfaSetupKey?.otpAuthUrl || ''} size={200} />
                            </div>
                            <p>
                                Alternatively, you can enter this code manually:
                                <br />
                                <strong>{mfaSetupKey?.manualEntryKey}</strong>
                            </p>
                        </div>

                        <ButtonRow alignment="right" className="top-margin">
                            {cancelAction && (
                                <ActionButton color="grey" onClick={cancelAction}>
                                    Cancel
                                </ActionButton>
                            )}
                            <ActionButton color="green" onClick={() => setStage('verify')}>
                                Next
                            </ActionButton>
                        </ButtonRow>
                    </DataCheck>

                    {fetchError && (
                        <ButtonRow alignment="right" className="top-margin">
                            {cancelAction && (
                                <ActionButton color="grey" onClick={cancelAction}>
                                    Close
                                </ActionButton>
                            )}
                        </ButtonRow>
                    )}
                </>
            )}
            {stage === 'verify' && (
                <>
                    <p>Enter the code from your authenticator app to verify.</p>
                    <Form
                        omitCancelButton={hasMfa}
                        onCancel={() => setStage('setup')}
                        cancelText="Back"
                        onSubmit={handleSubmit}
                        isPosting={isPosting}
                        error={postError}
                    >
                        <FormRow>
                            <TextInput
                                required
                                name="mfaToken"
                                value={formState.mfaToken}
                                onChange={handleChange}
                                label="Enter Code"
                            />
                        </FormRow>
                    </Form>
                </>
            )}
        </>
    );
};

interface MfaInnerProps {
    stage: 'setup' | 'verify';
    setStage: React.Dispatch<React.SetStateAction<'setup' | 'verify'>>;
    isFetching: boolean;
    fetchError: string | null;
    mfaSetupKey: MfaSetupKey | null;
    hasMfa?: boolean;
    handleSubmit: () => void;
    isPosting: boolean;
    postError: string | null;
    formState: { mfaToken: string };
    handleChange: <T>(name: string, value: T) => void;
    cancelAction?: () => void;
}

export default MfaInner;
